import React from "react";
import { MessageBanner } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
/**
 * Marks a local-only authority on a person detail: the person is kept in
 * ReČeK only and was not sent to NK authorities (DB-635).
 */
export var LocalAuthorityBanner = function (_a) {
    var person = _a.person;
    if (person.localOnly !== true) {
        return null;
    }
    return (React.createElement(MessageBanner, { type: "default" },
        React.createElement(FormattedMessage, { id: "ui-br-agency.person.localOnly.indicator" })));
};
